module.exports = __webpack_public_path__ + "static/img/av5.0e525634.png";